import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Social from '../views/Social.vue'
import Listen from '../views/Listen.vue'
import Tour from '../views/Tour.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/social',
    name: 'Social',
    component: Social
  },
  {
    path: '/listen',
    name: 'Listen',
    component: Listen
  },
  {
    path: '/tour',
    name: 'Tour',
    component: Tour
  },
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router